<template>
  <standard-dialog
    v-model="show"
    :title="$t('kds_prep_time_question')"
    icon="mdi-timer-outline"
    max-width="420"
    hide-actions
  >
    <v-btn x-large block depressed color="primary" dark class="mb-4" @click="$emit('ready-now')">
      <v-icon left>mdi-lightning-bolt</v-icon>
      {{ $t("kds_ready_immediately") }}
    </v-btn>
    <v-btn
      v-for="minutes in prepTimeOptions"
      :key="minutes"
      depressed
      x-large
      block
      color="success"
      dark
      class="mb-4"
      @click="$emit('select-minutes', minutes)"
    >
      {{ minutes }} min
    </v-btn>
  </standard-dialog>
</template>

<script>
import StandardDialog from "@/components/dialogs/StandardDialog.vue";

// Mirrors KDS_PREP_TIME_OPTIONS in src/pages/guest/kds/kdsConstants.js so the
// same "ready in X minutes" prompt appears when accepting an order from the
// guest report tables, not just from the kitchen display board.
const PREP_TIME_OPTIONS = [5, 10, 15, 20, 30, 45];

export default {
  name: "PrepTimeDialog",
  components: { StandardDialog },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      prepTimeOptions: PREP_TIME_OPTIONS,
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
